import { mappers } from '@ps/web-poker-tile-mappers';
import produce from 'immer';

import { type GamesUpdatePayload, UpdateType } from '../../types/Game';
import type { PokerSpinAndGoState } from '../types';

const updateGames = (
  state: PokerSpinAndGoState,
  { games, locale, isPlayMoney, operationType }: GamesUpdatePayload
) =>
  produce(state, (draft) => {
    const gameIds = draft.games.map((game) => game.scriptId);

    switch (operationType) {
      case UpdateType.Initial:
        draft.games = mappers.mapSagGames({
          sagGames: games,
          locale,
          isPlayMoney
        });
        break;
      case UpdateType.Create:
        draft.games.push(
          ...mappers.mapSagGames({
            sagGames: games,
            locale,
            isPlayMoney
          })
        );
        break;
      case UpdateType.Delete:
        for (const game of games) {
          const gameIndex = gameIds.indexOf(game.information.scriptId);
          draft.games.splice(gameIndex, 1);
        }
        break;
      case UpdateType.Update: {
        for (const game of games) {
          const gameIndex = gameIds.indexOf(game.information.scriptId);
          const currentGame = draft.games?.[gameIndex];
          const [newGame] = mappers.mapSagGames({
            sagGames: [game],
            locale,
            isPlayMoney
          });
          if (newGame) {
            draft.games[gameIndex] = { ...currentGame, ...newGame };
          }
        }
        break;
      }
    }

    return draft;
  });

export default updateGames;
